import axios from 'axios'
import { IBundle } from 'entities/cdn'

export const cdnBaseUrl = 'https://revix-prod-cdn-public.azureedge.net/'

export type ITimeFrameValue = '1' | '7' | '30' | '90' | '365' | 'All';

export type IFiatCode = 'ZAR' | 'GBP' | 'EUR' | 'USD'

export type IProductType = 'crypto' | 'bundle' | 'theme' | 'vault'

export const fetchPriceChart = async ({
    productCode,
    productType,
    timeFrame,
    baseCurrency
}: {
    productCode: string,
    productType: IProductType,
    timeFrame: ITimeFrameValue,
    baseCurrency: string
    }) => {
    const code = productCode?.toUpperCase()
    const url = `${cdnBaseUrl}datanew/graphs/${productType === 'theme' ? `${code}.LSE` : code}/${baseCurrency?.toUpperCase()}/rates_${timeFrame}.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })

        return response.data;
    } catch (error: any) {
        return error;
    }
}

export const fetchBundles = async () => {
    const url = `${cdnBaseUrl}data/bundles.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })

        const result = response.data;
        return result;
    } catch (error: any) {
        return error;
    }
}

export const fetchBundle = async ({
    code
}: {
    code: string | null
}) => {
    const url = `${cdnBaseUrl}data/bundles.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })

        const result = response.data?.filter?.((bundle: IBundle) => bundle.Code === code?.toUpperCase());
        return result;
    } catch (error: any) {
        return error;
    }
}

export const fetchCurrenciesList = async () => {
    const url = `${cdnBaseUrl}mobile/currencies/currencies_list.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })

        const result = response.data;
        return result;
    } catch (error: any) {
        return error;
    }
}

export const fetchProductsList = async () => {
    const url = `${cdnBaseUrl}web/products/products_list.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })

        const result = response.data;
        return result;
    } catch (error: any) {
        return error;
    }
}

export const fetchMetrics = async ({
    fromProduct,
    toProduct,
    toProductType
}: {
    fromProduct: string,
    toProduct: string,
    toProductType: string
}) => {
    const url = `${cdnBaseUrl}datanew/graphs/${toProductType === 'theme' ? `${toProduct}.LSE` : toProduct}/${fromProduct}/metrics.json`
    try {
        const response = await axios({
            method: 'GET',
            url
        })
        return response;
    } catch (error: any) {
        return error;
    }

}